import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(10),
  },
  sectionTitle: {
    borderBottom: '2px solid #DFDFDF',
    padding: theme.spacing(3),
  },
}));

export default function PrivilegesTable() {
  const classes = useStyles();
  return (
    <Grid className={classes.grid} maxwidth="lg">
      <Paper>
        <Typography className={classes.sectionTitle} variant="h5" component="h3">
          Privileges
        </Typography>
      </Paper>
    </Grid>
  );
}
